class CustomForm {
  constructor(object, isValid) {
    this.object = object
    this.isValid = isValid
    this.bindEvent()
  }
}

export default CustomForm